import {
  OnDestroy,
  AfterViewInit,
  ViewChild,
  Injector,
  OnInit,
  EventEmitter
} from "@angular/core";
import { ServiceManager } from "../../service-manager";
import { ListAction } from "../../helpers/enums";
import { ListTemplateComponent } from "./list-template.component";
import { ListEventArgs } from "./list-utils";
import { appInjector } from "../../helpers/app-injector";
import { BlockerManager } from "../../helpers/modal-option";
import { ISearchHost } from "../../interfaces/utils.interface";
import { SearchService } from "../../services/search.service";
import { Subscription } from "rxjs/internal/Subscription";
import { ConfigService } from "../../services/config.service";
import { ComponentManager } from "../../component-manager";

export class ListManager
  implements ISearchHost, OnInit, OnDestroy, AfterViewInit {
  @ViewChild(ListTemplateComponent)
  listTemplate: ListTemplateComponent;

  injector: Injector = appInjector();
  configService: ConfigService;
  blocker: BlockerManager;
  onInitialize = new EventEmitter();
  onDestroy = new EventEmitter();
  showSearchBar = true;

  private _searchService: SearchService;
  private _actionSubscription: Subscription;

  constructor(public serviceManager?: ServiceManager<any>) {
    if (serviceManager) {
      serviceManager.callerComponent.host = "list";
    }

    this.configService = this.injector.get(ConfigService);
    this.blocker = new BlockerManager(this.injector.get(ConfigService));
    this._searchService = this.injector.get(SearchService);

    if (this._searchService) {
      this._searchService.activeComponent = this;
    }
  }

  ngOnInit() {
    this.serviceManager.callerComponent.state = "initializing";
    this.onInitialize.emit({
      showSearchBar: this.showSearchBar
    });
  }

  ngAfterViewInit() {
    this._actionSubscription = this.listTemplate.onActionChange.subscribe(
      (args: ListEventArgs) => {
        switch (args.sender) {
          case ListAction.Add:
            this.onAdd();
            break;

          case ListAction.Delete:
            this.onDelete(args.model);
            break;

          case ListAction.Edit:
            this.onEdit(args.model);
            break;

          case ListAction.Paginate:
            this.onPaginate();
            break;

          case ListAction.Refresh:
            this.onRefresh();
            break;
        }
      }
    );
  }

  onAdd() {
    if (this.serviceManager) {
      this.serviceManager.add();
    }
  }

  onDelete(model: any) {
    if (this.serviceManager) {
      this.serviceManager.delete(model);
    }
  }

  onEdit(model: any) {
    if (this.serviceManager) {
      this.serviceManager.callerComponent.host = "list";
      this.serviceManager.edit(model);
    }
  }

  onPaginate() {
    if (this.serviceManager) {
      this.serviceManager.load(this.listTemplate.requestSetting);
    }
  }

  onRefresh() {
    if (this.serviceManager) {
      this.serviceManager.refresh();
    }
  }

  ngOnDestroy() {
    this.onDestroy.emit({
      showSearchBar: false
    });

    if (this.serviceManager) {
      this.serviceManager.callerComponent.state = "destroying";
      if (this._actionSubscription) {
        this._actionSubscription.unsubscribe();
      }
    }
  }

  get componentManager(): ComponentManager<any> {
    return this.serviceManager.componentManager;
  }
}
